/**
 * 项目默认配置项
 * primaryColor - 默认主题色, 如果修改颜色不生效，请清理 localStorage
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * colorWeak - 色盲模式
 * layout - 整体布局方式 ['sidemenu', 'topmenu'] 两种布局
 * fixedHeader - 固定 Header : boolean
 * fixSiderbar - 固定左侧菜单栏 ： boolean
 * contentWidth - 内容区布局： 流式 |  固定
 *
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 *
 */

export default {
  navTheme: 'dark', // theme for nav menu
  // 主品牌色 #0FAE6C，Hover #0C9A5F，次级 #5BD1A1，辅助背景 #E8F6F0，边框 #CFEBDD，禁用 #8FBFA8
  primaryColor: '#00BFA5', // 主品牌色 - 核心品牌识别、主操作
  layout: 'sidemenu', // nav menu position: `sidemenu` or `topmenu`
  contentWidth: 'Fluid', // layout of content: `Fluid` or `Fixed`, only works when layout is topmenu
  fixedHeader: true, // sticky header
  fixSiderbar: true, // sticky siderbar
  colorWeak: false,
  menu: {
    locale: false
  },
  openKeys: [
    '/configCenter',
    '/distributorb',
    '/orderManage',
    '/statistics',
    '/longterm',
    '/merchant',
    '/otherBusiness',
    '/settledBill',
    '/settleb',
    '/refund',
    '/reconciliation',
    '/subTrade',
    '/hosting',
    '/runService',
    '/monitor'
  ],
  multiTab: true,
  title: '釜猫智慧停车',
  pwa: false,
  iconfontUrl: '',
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true'
}
